import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#241813] text-[#d9c9b7] mt-24">
      <div className="max-w-[1680px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img
            src="/velouva-logo.jpg"
            alt="VELOUVA Cosmetic"
            className="h-24 w-24 object-contain -ml-2"
            style={{ filter: 'invert(1)', mixBlendMode: 'lighten' }}
          />
          <p className="mt-4 max-w-sm text-[15px] leading-[1.7] text-[#bcaa97]">
            VELOUVA is a modern beauty brand dedicated to creating high-quality, long-lasting, and skin-friendly cosmetics. We believe beauty should be effortless, empowering, and accessible to everyone. Our products are designed to deliver exceptional performance while ensuring comfort and confidence throughout the day.
          </p>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.28em] border-t border-[#3d2c22] pt-3 inline-block">ASSISTANCE</div>
          <ul className="mt-6 space-y-3 text-[14px]">
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
            <li><Link to="/shipping-policy" className="hover:text-white transition-colors">Shipping Policy</Link></li>
            <li><Link to="/return-policy" className="hover:text-white transition-colors">Return &amp; Refund Policy</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.28em] border-t border-[#3d2c22] pt-3 inline-block">COLLECTIONS</div>
          <ul className="mt-6 space-y-3 text-[14px]">
            <li><Link to="/shop" className="hover:text-white transition-colors">All Shades</Link></li>
            <li><Link to="/quiz" className="hover:text-white transition-colors">Find Your Shade</Link></li>
            <li><Link to="/account" className="hover:text-white transition-colors">My Account</Link></li>
            <li><Link to="/login" className="hover:text-white transition-colors">Sign In</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#3d2c22]">
        <div className="max-w-[1680px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[11px] tracking-[0.22em] text-[#a89784]">
          <div>™ Velouva Cosmetics. All Rights Reserved.</div>
          <div>COMPOSED IN INDIA · SHIPPED ACROSS INDIA</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
